import { z } from 'zod';
import { avatarUrlSchema } from '@/utils/schemas';

export const userInfoByCodeScheme = z.object({
  UID: z.number(),
  NickName: z.string(),
  HeadImg: avatarUrlSchema,
  Gender: z.union([z.literal(0), z.literal(1), z.literal(2)]),
  Sign: z.string().default(''),
});

export type UserInfoByCode = z.infer<typeof userInfoByCodeScheme>;

export const otherUserInfoScheme = userInfoByCodeScheme.extend({
  IsFriend: z.boolean().nullish(),
});

export type OtherUserInfo = z.infer<typeof otherUserInfoScheme>;
